import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FiMenu, FiX } from 'react-icons/fi';
import { useSiteLanguage } from '../i18n/siteLanguage';
import styles from './Header.module.css';

/**
 * Public-facing header with navigation.
 */
function Header() {
  const { user } = useSelector((state) => state.auth);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { language, setLanguage } = useSiteLanguage();
  const isGreek = language === 'el';

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);
  const localizePath = (path) => (language === 'el' ? (path === '/' ? '/el' : `/el${path}`) : path);

  return (
    <header className={styles.header}>
      <div className={`container ${styles.inner}`}>
        <Link to={localizePath('/')} className={styles.logo}>
          <img src="/digitized-menu-logo.svg" alt="digitizedmenu.com" className={styles.logoImage} />
        </Link>

        <nav className={styles.nav}>
          <Link to={localizePath('/use-cases')} className={styles.navLink}>{isGreek ? 'Κλάδοι' : 'Use Cases'}</Link>
          <Link to={localizePath('/features')} className={styles.navLink}>{isGreek ? 'Δυνατότητες' : 'Features'}</Link>
          <Link to={localizePath('/pricing')} className={styles.navLink}>{isGreek ? 'Τιμολόγηση' : 'Pricing'}</Link>
          <Link to={localizePath('/faq')} className={styles.navLink}>FAQ</Link>
          <Link to={localizePath('/contact')} className={styles.navLink}>{isGreek ? 'Επικοινωνία' : 'Contact'}</Link>
          <div className={styles.langSwitch}>
            <button
              type="button"
              className={`${styles.langBtn} ${language === 'en' ? styles.langBtnActive : ''}`}
              onClick={() => setLanguage('en')}
            >
              EN
            </button>
            <button
              type="button"
              className={`${styles.langBtn} ${language === 'el' ? styles.langBtnActive : ''}`}
              onClick={() => setLanguage('el')}
            >
              EL
            </button>
          </div>
          {user ? (
            <Link to="/dashboard" className="btn btn-primary">{isGreek ? 'Πίνακας Ελέγχου' : 'Dashboard'}</Link>
          ) : (
            <>
              <Link to={localizePath('/login')} className={styles.navLink}>{isGreek ? 'Σύνδεση' : 'Log in'}</Link>
              <Link to={localizePath('/register')} className="btn btn-primary">{isGreek ? 'Εγγραφή' : 'Sign up'}</Link>
            </>
          )}
        </nav>

        <button
          type="button"
          className={styles.hamburger}
          onClick={toggleMobileMenu}
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
        >
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      <div className={`${styles.mobileMenu} ${mobileMenuOpen ? styles.mobileMenuOpen : ''}`}>
        <Link to={localizePath('/use-cases')} className={styles.mobileLink} onClick={() => setMobileMenuOpen(false)}>{isGreek ? 'Κλάδοι' : 'Use Cases'}</Link>
        <Link to={localizePath('/features')} className={styles.mobileLink} onClick={() => setMobileMenuOpen(false)}>{isGreek ? 'Δυνατότητες' : 'Features'}</Link>
        <Link to={localizePath('/pricing')} className={styles.mobileLink} onClick={() => setMobileMenuOpen(false)}>{isGreek ? 'Τιμολόγηση' : 'Pricing'}</Link>
        <Link to={localizePath('/faq')} className={styles.mobileLink} onClick={() => setMobileMenuOpen(false)}>FAQ</Link>
        <Link to={localizePath('/contact')} className={styles.mobileLink} onClick={() => setMobileMenuOpen(false)}>{isGreek ? 'Επικοινωνία' : 'Contact'}</Link>
        <div className={styles.mobileLangSwitch}>
          <button type="button" className={styles.mobileLangBtn} onClick={() => setLanguage('en')}>English</button>
          <button type="button" className={styles.mobileLangBtn} onClick={() => setLanguage('el')}>Ελληνικά</button>
        </div>
        {user ? (
          <Link to="/dashboard" className={styles.mobileLink} onClick={() => setMobileMenuOpen(false)}>{isGreek ? 'Πίνακας Ελέγχου' : 'Dashboard'}</Link>
        ) : (
          <>
            <Link to={localizePath('/login')} className={styles.mobileLink} onClick={() => setMobileMenuOpen(false)}>{isGreek ? 'Σύνδεση' : 'Log in'}</Link>
            <Link to={localizePath('/register')} className={styles.mobileLinkPrimary} onClick={() => setMobileMenuOpen(false)}>{isGreek ? 'Εγγραφή' : 'Sign up'}</Link>
          </>
        )}
      </div>
    </header>
  );
}

export default Header;
